export default "__VITE_ASSET__BV_Q4MIy__"